﻿import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Translate } from '../../../../../shared/LanguageService';
import notify from '../../../../../shared/feedback/notifications';

interface IConnectCubiCasaModalProps {
    closeModal: () => void;
    onSave: (value: string) => void;
    initialValue?: string;
    cubiCasaOrderId?: string;
}

const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

const ConnectCubiCasaModal = (props: IConnectCubiCasaModalProps) => {
    const [value, setValue] = React.useState(
        props.cubiCasaOrderId || props.initialValue || ''
    );

    const handleSave = () => {
        if (!guidRegex.test(value)) {
            notify.failure(Translate('view-order/admin-planorder/cubi-casa-info/modal/invalid-guid'));
            return;
        }
        props.onSave(value);
        props.closeModal();
    };

    return (
        <Dialog open onClose={props.closeModal} maxWidth="xs" fullWidth>
            <DialogTitle>
                {Translate('view-order/admin-planorder/cubi-casa-info/modal/title')}
            </DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    type="text"
                    fullWidth
                    value={value}
                    onChange={e => setValue(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button color="error"
                        variant="contained"
                        onClick={props.closeModal}>
                    {Translate('view-order/admin-planorder/cubi-casa-info/modal/cancel')}
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSave}
                    type="submit"
                    disabled={!value.trim()}
                >
                    {Translate('view-order/admin-planorder/cubi-casa-info/modal/save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConnectCubiCasaModal;
